/**
 * Куда вернуть человека после входа.
 *
 * Значение приходит снаружи — из состояния навигации, которое положил маршрут
 * `*`, — и уезжает либо в `navigate`, либо в `return_to` серверного редиректа
 * Яндекс ID. То есть это адрес, которым управляет тот, кто прислал ссылку.
 *
 * Одной проверки `startsWith('/')` **мало**. `//evil.example/` начинается со
 * слэша и при этом является протокол-относительным адресом: браузер подставит
 * текущую схему и уйдёт на чужой хост. Точно так же работает `/\evil.example`
 * — обратный слэш браузеры нормализуют в прямой. Оба варианта проходят наивную
 * проверку и дают открытый редирект **сразу после успешного входа**, то есть в
 * тот момент, когда человек только что доверился настоящему домену и ввёл
 * пароль. Это готовая фишинговая воронка, а не теоретическая дыра.
 *
 * Проверка живёт одной функцией и зовётся из всех трёх точек (`main.tsx`,
 * `Login.tsx`, `api/auth.ts`): до неё правильная проверка стояла в одной из
 * трёх, а две повторяли слабую. Дыра, закрытая в одном месте из трёх, — это не
 * закрытая дыра, а ложное спокойствие.
 *
 * Фронт тут **вторая линия**. `return_to` обязан проверять и сервер: до него
 * значение доезжает в запросе, который можно собрать руками, минуя кабинет.
 */

/**
 * Путь внутри кабинета или `/`.
 *
 * Пропускаем только то, что начинается с одного прямого слэша и не начинается
 * со второго слэша или обратного. Список запрещённых начал, а не разбор через
 * `new URL`: разбор требует базы, и ошибиться в выборе базы легче, чем в двух
 * сравнениях.
 */
export function safePath(value: string | null | undefined): string {
  if (!value) return '/';
  if (!value.startsWith('/')) return '/';
  if (value.startsWith('//') || value.startsWith('/\\')) return '/';
  return value;
}
